import React, { useEffect } from 'react';
import { useMonitoring } from '../../utils/monitoring';
import { useIsSelfView } from '../../hooks/useIsSelfView';
import { useSellerData } from '../../hooks/useSellerData';
import { FederatedSeller } from '../../types';
import { NotableClients } from './NotableClients';
import { NotableClientsProps } from './types';
import { AddNotableClientsBlock } from './AddNotableClientsBlock/AddNotableClientsBlock';

export const NotableClientsResolver = (props: NotableClientsProps) => {
    const { fireEvents, Providers } = useMonitoring();
    const { notableClients } = useSellerData(selectSellerSlice);
    const isSelfView = useIsSelfView();

    const hasClients = notableClients.length > 0;

    useEffect(() => {
        if (hasClients) {
            fireEvents({
                [Providers.Mixpanel]: {
                    type: 'Notable client exist',
                },
            });
        }
    }, [Providers.Mixpanel, fireEvents, hasClients]);

    if (hasClients) {
        return <NotableClients {...props} />;
    }

    if (!hasClients && isSelfView) {
        return <AddNotableClientsBlock />;
    }

    return null;
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        notableClients: seller.notableClients,
    };
}

export default NotableClientsResolver;
